<!-- <p-dialog 
  [className]="'eccc'"
  [header]="title"
  [closable]="false"
  [(visible)]="visible"
  [modal]="true"
  [responsive]="true"
  [style]="{width: 'fit-content'}"
  [minY]="500"
  [maximizable]="false"
  [autoZIndex]="false"> -->

  <div class="panel">
        <formly-form *ngIf="type !== 'assignObligation'" [model]="remittanceData" [fields]="remittanceFormFields" [form]="remittanceForm">
        </formly-form>
     <p-fieldset *ngIf="type !== 'assignObligation'" legend="{{'OBLIGATION_MGMT_MODULE.ruInvalidForm.section181Details' | translate}}" fieldsetAriaFix>
      <formly-form [model]="remittanceData" [fields]="section181FormFields" [form]="section181Form">
      </formly-form>

    </p-fieldset>
    <formly-form *ngIf="type === 'assignObligation'" [model]="remittanceData" [fields]="section181FormFields" [form]="section181Form">
    </formly-form>
  </div>

  <ng-template pTemplate="footer">
    <div class="footer-buttons">
      <div class="float-right" *ngIf="!is181 || !remittanceData?.id">
        <button id="submitBtn" type="button" class="btn btn-primary mr-2" (click)="submit()">{{'COMMON.actionsLabel.SUBMIT' | translate}}</button>
      </div>

      <div class="float-right"  *ngFor="let button of buttons; let i = index">
        <button type="button"
                *ngIf="showButton(button)"
                [id]="button.id"
                class="btn btn-primary mr-3"
                (click)="executeReviewActions(button)">{{ button.label | translate }}</button>
       </div>
    </div>
  </ng-template>

<!-- </p-dialog> -->
